import React, { useCallback, useEffect, useState } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { InnerViewProps, UserGuideGroup } from '../types';
import { getUserGuideGroupsList } from '../utils';
import GuideBlock from './GuideBlock';

const HelpAttachmentGuides: React.FC<InnerViewProps> = ({
  setCurrentView,
  goBack,
  appData,
}) => {
  const [items, setItems] = useState<UserGuideGroup[]>([]);

  const getFaqs = useCallback(async () => {
    try {
      const categories = await getUserGuideGroupsList(appData.appToken);
      setItems(categories);
    } catch (error) {
      setItems([]);
    }
  }, [appData.appToken]);

  useEffect(() => {
    getFaqs();
  }, [getFaqs]); //

  return (
    <>
      <div className="bg-gradient-to-b from-green-500 to-green-600 p-3 py-5 flex justify-between items-center">
        <div
          onClick={goBack}
          className="cursor-pointer hover:bg-green-700 p-2 rounded"
        >
          <AiOutlineArrowLeft />{' '}
        </div>
        <div className="font-medium text-lg">Guides</div>
        <div className="w-6"></div>
      </div>
      <div className="p-4 text-black">
        <h4 className="font-medium text-xl mt-3 w-5/6 mb-3">
          The {appData.appName} user guides are here to help you best use our
          features
        </h4>
        <p className="font-light text-gray-500 text-sm w-5/6 mb-10">
          Select from the categories below to find articles related to each
          section of the platform.
        </p>

        {items.map((item, index) => (
          <GuideBlock
            guide={item}
            key={index}
            showGuide={(guide: string) => {
              setCurrentView(`guides/${guide}`);
            }}
          />
        ))}
      </div>
    </>
  );
};

export default HelpAttachmentGuides;
